
    import {defineComponent, reactive} from 'vue';

    interface State {
        qualityList: object[];
    }

    export default defineComponent({
        name: "ratingCriteria",
        setup() {
            let state: State = reactive({
                qualityList: [
                    {
                        qualityLevel: '准新',
                        qualityName: '车况极品',
                        qualityDesc: '使用年限不超过1年，行驶里程不超过1.5万公里，车身外观、内饰完好，全车漆面无修复，准新车'
                    },
                    {
                        qualityLevel: '9新',
                        qualityName: '车况优秀',
                        qualityDesc: '使用年限不超过3年，车身外观形态完好，全车漆面光亮，车身外观、内饰仅存在细微瑕疵'
                    },
                    {
                        qualityLevel: '8新',
                        qualityName: '车况良好',
                        qualityDesc: '漆面有光泽，车身允许有局部补漆，全车结构件无事故类损伤，加强件无严重损伤，内饰存在少许轻微瑕疵，不影响功能使用，无任何重大事故，综合车况较好'
                    }
                ]
            })
            return {
                state
            }
        },
        methods: {}
    })
